import { IonApp, IonContent, IonRoute, IonRouterOutlet, IonSpinner, setupIonicReact, useIonRouter } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { useEffect } from "react";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

import "./components/index.css";
import { useState } from "react";
import FirebaseApp from "./Firebase";
import { getAuth } from "firebase/auth";
import { Routes } from "./routes/Routes";
import { ThemeProvider } from "styled-components";
import { theme } from "./styles/Theme";
import { GlobalStyle } from "./styles/Global";
import "react-toastify/dist/ReactToastify.css";
import { StyledToastContainer } from "./services/ToastService";
import { FirebaseAuthentication } from "@capacitor-firebase/authentication";
import SplashScreen from "./components/SplashScreen";
import Analytics from "./lib/anayltics";
import PWAUtil from "./lib/pwa";
import FreshchatService from "./services/FreshworksService";


setupIonicReact({
	mode: "md",
});

//TODO: FInd a better way to handle login status and firebase initialization.
//Preferably make a better version of the useauthProvider hook.

const App: React.FC = () => {

	//The inital state could be set depending on if the user has already previously logged in.

	const userId = window.localStorage.getItem("userId"), 
		isAuth: Boolean = (userId) ? true : false;
	const [isAuthenticated, setAuthStatus] = useState(isAuth);
	const [firebaseInitialized, setFirebaseInitialized] = useState<boolean>(false);
	const firebaseApp = FirebaseApp.getInstance();
	const auth = getAuth(firebaseApp);

	const handleStateChange = async ({ user }: any) => {
		//Firebase Initialized
		setFirebaseInitialized(true);
		if (user) {
			//Logging the user in
			setAuthStatus(true);
			//Get logged in user's storred id
			const userId = window.localStorage.getItem("userId");
			if(userId) {
				//Check if its the same as the logged in user or replace it with the current
				if(userId !== user.uid) {
					window.localStorage.setItem("userId", user.uid);
				}		
			}
			else {
				//Setting the userid to localstorage to keep the user logged in.
				window.localStorage.setItem("userId", user.uid);
			}
			Analytics.identifyUser(user.uid);
			FreshchatService.initialize(user);
		} else {
			window.localStorage.removeItem("userId");
			setAuthStatus(false);
		}
	};

	useEffect(() => {
		Analytics.loadAnaylticsModule();
		FirebaseAuthentication.addListener("authStateChange", handleStateChange);
		// PWAUtil.setupPWAEventListeners();
	}, []);

	return (
		<ThemeProvider theme={theme}>
			<GlobalStyle />
			<IonApp className="safe-area">
				{(isAuthenticated && !firebaseInitialized) ? (
					<SplashScreen />
				) : (
					<IonReactRouter>
						<Routes isAuthenticated={isAuthenticated} />
					</IonReactRouter>
				)}
				<StyledToastContainer />
			</IonApp>
		</ThemeProvider>
	);
};

export default App;